import React, { useEffect, useState } from 'react';
import { Box, Button, IconButton } from '@mui/material';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import format from 'date-fns/format';

import { collection, addDoc, doc, deleteDoc, orderBy, query, getDocs } from 'firebase/firestore';
import { db, logMe } from '../../firebase';
import { onSnapshot } from 'firebase/firestore';
import AdminNavbar from '../../components/AdminNavbar';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LoadingButton } from '@mui/lab';
import { Container } from '@mui/system';
import DeleteIcon from '@mui/icons-material/Delete';

function Coupon() {
  const [couponList, setCouponList] = useState([]);
  const [code, setCode] = useState("")
  const [percent, setPercent] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [loading, setLoading] = useState(false);

  const discountsCol = collection(db, 'discounts');
  const ticketPurchaseCollection = collection(db, 'ticketPurchases');

  const getCoupons = async () => {
    logMe('getCoupons');
    const ticketPurchasesQuery = query(ticketPurchaseCollection);
    const ticketPurchasesQuerySnapshot = await getDocs(ticketPurchasesQuery);

    let ticketPurchases = [];
    ticketPurchasesQuerySnapshot.forEach((doc) => {
      ticketPurchases.push({ ...doc.data(), id: doc.id })
    });
    const discountQuery = query(discountsCol, orderBy('expiryDate', 'desc'));
    const discountQuerySnapshot = await getDocs(discountQuery);
    const list = [];
    discountQuerySnapshot.forEach((doc) => {
      const purchasesMatched = ticketPurchases
        ?.filter((ticketPurchase) => ticketPurchase.discountCode === doc.data().code)
        
      const numberOfUsed = purchasesMatched?.length || 0;

      const totalAmountDiscounted = purchasesMatched
        ?.reduce((acc, curr) => acc + (curr.originalAmountCents - curr.amountCents), 0)

      const totalAmountCollected = purchasesMatched
        ?.reduce((acc, curr) => acc + curr.amountCents, 0)


      list.push({ ...doc.data(), numberOfUsed, totalAmountDiscounted, totalAmountCollected, id: doc.id });
    });
    setCouponList(list);
  }

  useEffect(() => {

    getCoupons();

    // onSnapshot(query(discountsCol, orderBy('expiryDate', 'desc')), (querySnapshot) => {
    //   const list = [];
    //   querySnapshot.forEach((doc) => {
    //     list.push({ ...doc.data(), id: doc.id });
    //   });
    //   setCouponList(list);
    // });
  }, []);

  const addCoupon = async () => {
    setLoading(true)
    await addDoc(discountsCol, {
      code,
      percent,
      expiryDate,
    })
    setLoading(false);
    setCode("");
    setPercent("");
    setExpiryDate("");
    getCoupons();
  };

  const deleteCoupon = async (id) => {
    const discountsRef = doc(db, 'discounts', id);
    try {
      await deleteDoc(discountsRef);
      getCoupons();
    } catch (err) {
      alert(err);
    }
  };


  return (
    <>
      <AdminNavbar />
      <Container component="main" maxWidth="xs">
        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper', paddingBottom: '20px', boxShadow: 2, margin: '20px auto', alignItems: 'center', textAlign: 'center', }}>
          <ListItem sx={{ textAlign: 'center', margin: '0 auto' }}>
            <TextField
              autoComplete="code"
              name="code"
              required
              fullWidth
              id="code"
              sx={{ m: 1, width: '23ch', margin: '0 auto' }}
              value={code}
              onChange={event => setCode(event.target.value)}
              label="Code"
              autoFocus
            />
          </ListItem>
          <ListItem>
            <TextField
              label="Percent"
              type="number"
              value={percent}
              sx={{ m: 1, width: '70%', margin: '0 auto' }}
              InputProps={{
                startAdornment: <InputAdornment position="start">%</InputAdornment>,
              }}
              onChange={event => setPercent(event.target.value)}
            />
          </ListItem>
          <ListItem sx={{ paddingLeft: '18%' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} >
              <DesktopDatePicker
                label="Expiry Date"
                disablePast
                value={expiryDate}
                onChange={newDate => setExpiryDate(newDate.format('YYYY-MM-DD'))}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </ListItem>
          <LoadingButton
            disabled={!code || !percent || !expiryDate}
            loading={loading}
            sx={{ margin: '0 auto', marginTop: 2, alignItems: 'center' }}
            onClick={addCoupon}
            variant='contained'
          >
            Generate a Coupon
          </LoadingButton>
        </List>


        <h2>Coupons</h2>
        <List sx={{ width: '100%', maxWidth: 360, margin: '0 auto', marginTop: 2, alignItems: 'center' }}>
          {couponList.map((coupon, index) => {
            return (
              <ListItem
                key={index}
                secondaryAction={
                  <IconButton onClick={() => deleteCoupon(coupon.id)} edge="end" aria-label="comments">
                    <DeleteIcon />
                  </IconButton>
                }
                disablePadding
              >
                <ListItemText
                  primary={
                    `Code: ${coupon.code} (${coupon.percent}%) ${coupon.expiryDate}`
                  }
                  secondary={`${coupon.numberOfUsed} used (Discounted $${coupon.totalAmountDiscounted / 100}) (Collected $${coupon.totalAmountCollected / 100})`}
                />
              </ListItem>
            );
          })}
        </List>
      </Container>
    </>
  );
}

export default Coupon;
